import { TReduxActions } from '../../../types/redux';
import { EAnswerTextTypes } from '../../../actions/newAnswer';
import { TAnswer } from '../../../types/newAnswer';
import { ENewAnswerForm } from '../../../actions/newAnswer/newAnswearAction';

export const defaultValue = {
  value: '',
};

export function answerTextReducer(state: TAnswer = defaultValue, { type, payload }: TReduxActions): TAnswer {
  if (type === EAnswerTextTypes.Set) {
    return {
      value: payload as string,
    };
  }

  if (type === ENewAnswerForm.Clear) {
    return defaultValue;
  }

  return state;
}
